import Image            from "gatsby-image";
import React            from "react";
import OgImage          from "../../../../assets/images/blog/article_13/kilka-slow-o-content-marketingu_og.png";
import {useAuthorsData} from "../../Authors/useAuthorsData";
import {ArticlePhotos}  from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();
  return {
    date:              "11.01.2022r",
    category:          "content marketing, strategia",
    title:             <>Kilka słów o content <br/>marketingu</>,
    SEO_title:         "Kilka słów o content marketingu",
    description:
                       <>Często nie zdajemy sobie sprawy, jak wielką moc mają słowa. Zarówno te wypowiadane codziennie do rodziny, znajomych, pracowników, jak również te, które trafiają do nas z&nbsp;telewizji, internetu, bilbordów. Dopóki nie zdasz sobie sprawy, jak ważne są słowa, nie pojmiesz ogromnego znaczenia content marketingu. A&nbsp;dzięki odpowiednio dobranym treściom możesz tworzyć komunikaty, które wyróżnią Twoją markę!</>,
    seo:
                       "Dopóki nie zdasz sobie sprawy, jak ważne są słowa, nie pojmiesz ogromnego znaczenia content marketingu. A dzięki odpowiednio dobranym treściom możesz tworzyć komunikaty, które wyróżnią Twoją markę! ",
    slug:              "/blog/kilka-slow-o-content-marketingu",
    image:             OgImage,
    authors:           [
      authors.JustynaBak,
    ],
    hero:              (
                         <Image
                           alt=""
                           objectPosition={"center"}
                           objectFit={"contain"}
                           fluid={images.hero.childImageSharp.fluid}
                         />
                       ),
    text:              {
      first:   {
        title: "Co to właściwie jest?",
        text:
               <><strong>Content marketing jest marketingiem treści.</strong> To cała strategia, która polega na pozyskiwaniu nowych klientów dzięki publikowaniu atrakcyjnego i&nbsp;interesującego contentu. Ale to nie wszystko! Bo poza tym, że treści powinny być ciekawe, to powinny być również angażujące. Powinny zachęcać klientów do działania, odwiedzenia naszej strony, sprawdzenia produktu, poznania firmy, zakupu itd. Marketing treści zakłada długotrwałe relacje z odbiorcą właśnie poprzez zaangażowanie i&nbsp;interakcję. Treści content marketingowe są publikowane w&nbsp;internecie w postaci artykułów, postów, poradników, newsletterów, treści na stronach internetowych. Są to również teksty tworzone w&nbsp;prasie, ulotkach, katalogach, telewizji, reklamach wideo itd. Content marketing powinien obejmować każdy kanał, w&nbsp;którym marka ma szansę zaistnieć.</>,
      },
      second:  {
        title: "Krótki poradnik o content marketingu",
        text:  "Artykułów i poradników o marketingu treści oraz o tym, jak krok po kroku stworzyć niepowtarzalny content, powstało już wiele. Dlatego przedstawiamy najważniejsze punkty, na których warto się skupić!"
      },
      third:   {
        title: "Przygotuj dobrą strategię",
        text:  "Ważną kwestią jest opracowanie strategii, czyli działań odpowiednio zaplanowanych w czasie. Ich celem jest osiąganie korzyści biznesowych - wzrost sprzedaży, większa rozpoznawalność marki, budowanie pozycji eksperckiej marki itd. Działania rozpisane w strategii content marketingowej polegają na tym, by budować obecność marki przez angażujące i wartościowe treści. Dzięki nim użytkownicy i klienci sami do nas trafią. Dobra strategia powinna uwzględniać działania content marketingowe pojawiające się na każdym szczeblu procesu decyzyjnego i zakupowego klienta. Bo przecież finalnie wszystkim chodzi o sprzedaż.",
      },
      fourth:  {
        title: "Spójrz oczami swojego klienta",
        text:  <>
                 Przede wszystkim należy poznać swojego odbiorcę. Aby tego dokonać, trzeba przeprowadzić analizę grupy docelowej. Publikowane treści muszą być precyzyjnie dopasowane do grupy docelowej, aby mogły faktycznie zainteresować.<strong> Poznanie i&nbsp;zrozumienie swoich potencjalnych klientów jest kluczowe w content marketingu.</strong> Pomocne w tym wypadku jest stworzenie persony, czyli idealnego klienta. Trzeba postarać się "wejść w buty swojego klienta", popatrzeć na nasz produkt jego oczami i&nbsp;opisać, kim jest z zawodu, czym się charakteryzuje, co może go skłonić do zainteresowania naszą marką, do kupna naszego produktu, a&nbsp;co może być czynnikiem, który go zniechęci do zakupu. Warto również zastanowić się, jak na niego wpłynąć, by kupił dany produkt czy skorzystał z usługi.
               </>
      },
      fifth:   {
        title: "Dobierz odpowiednie narzędzia",
        text:  "W content marketingu ważne jest dopasowanie unikalnych treści do precyzyjnie dobranej grupy klientów, czyli do opisanej wyżej odpowiedniej persony. Trzeba również wybrać właściwe kanały komunikacji. Mając dwie różne grupy klientów (np. pod względem wieku, wykształcenia i średnich zarobków), do każdej z nich musimy podejść indywidualnie i docierać inaczej, stosując różny content oraz kanały komunikacji. W takim wypadku nasze działania przyniosą oczekiwane efekty. Trzeba również pamiętać o jednym. Promuj swoje treści. Same nie dotrą do odbiorcy."
      },
      sixth:   {
        title: "SEO krok po kroku",
        text:  "Tworząc treści marketingowe, nie można zapominać o pozycjonowaniu. SEO to podstawa widoczności w sieci. Dlatego pisząc artykuły na blogu, uwzględnij słowa kluczowe. Zoptymalizuj wszelkiego rodzaju grafiki, wykresy, gify czy filmy. Zadbaj o poprawne linkowanie. Zrób wszystko, by Twoje treści dotarły do jak największej grupy odbiorców i wyróżniły się wśród konkurencji."
      },
      seventh: {
        title: "",
        text:  <>Masz pytania? Skontaktuj się, a specjaliści InteractiveVision opracują dla Ciebie <strong>strategię content marketingową!</strong></>
      },
    },
    imagesWithCaption: {
      first: {
        img:   (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.img_1.childImageSharp.fluid}
                 />
               ),
        width: 871,
      },
    }
  };
};
